// Librerias
import React, { PropTypes, Component } from 'react'
import api from '../../../apiClient/v1'
// Componentes
import { RowOperador, RowOperadorReemplazo, RowOperadorReemplazoSEI, RowOperadorSEI, RowOperadorSEIEscondido } from './RowOperador.jsx'
import { SelectAlternateLeader } from './SelectAlternateLeader.jsx'
import { HeaderConBusqueda } from '../../../components/shared/HeaderConBusqueda.jsx'
import { ModalTrigger, ModalAgregaOperador, ModalEnrocarOperadores, ModalPendientesRegion } from './Modales.jsx'
// CSS
import * as css from './PanelCaptador.css'
import { createSelectorHook } from 'react-redux'
import TarifaNomina from '../tarifa/TarifaNomina.jsx'
import Pasaje from '../pasaje/Pasaje.jsx'
import TurnoEmergencia from '../turnoEmergencia/TurnoEmergencia.jsx'
let panelConteo = [
    'panel-primary',
    'panel-danger',
    'panel-warning',
    'panel-success',
    'panel-info',
    'panel-info',
    'panel-primary'
]

export class PanelCaptadorSEI extends Component {
    constructor(props) {
        super(props)
        this.state = {
            substitutesOperatorsRaw: this.props.captadorSEI.dotacionReemplazo,
            substitutesOperators: [],
            titularOperatorsRaw: this.props.captadorSEI.dotacionTitular,
            titularOperators: [],
            valueSearchRUN: '',
            valueSearchName: '',
            valueSearchComuna: '',
            checkOperadores: [],
            checkOperadoresTitular: [],
            enroque: false,
            showPendientesRegion: false,
            selectedPermisoId: "",
            activarPermisoMall: false,
            avisoReemplazosVisible: false,
        }

        this.searchingText = (camp, originalSearch) => {
            let newState = {}
            newState[camp] = originalSearch.trim().toLowerCase()
            this.setState(newState, this.filterOperators)
        }
        this.filterOperators = () => {
            let titulares = this.state.titularOperatorsRaw
            let substitutes = this.state.substitutesOperatorsRaw
                .filter(us => us.usuarioRUN.indexOf(this.state.valueSearchRUN) >= 0)
                .filter(us => us.nombreCorto.toLowerCase().indexOf(this.state.valueSearchName) >= 0)
                .filter(us => us.comuna.toLowerCase().indexOf(this.state.valueSearchComuna) >= 0);
            let listCheck = substitutes.map((operador) => {
                return { id: operador.id, status: false }
            });
            let listCheckTitular = titulares.map((operador) => {
                return { id: operador.id, status: false }
            })
            this.setState({
                substitutesOperators: substitutes,
                checkOperadores: listCheck,
                titularOperators: titulares,
                checkOperadoresTitular: listCheckTitular
            })
        }
        this.setStatusCheckBox = (idOperator, status) => {
            let lista = this.state.checkOperadores.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadores: lista })
        }

        this.setStatusCheckBoxAll = (status) => {
            let lista = this.state.checkOperadores.map((operador) => {
                return { id: operador.id, status: status }
            })
            this.setState({ checkOperadores: lista })
        }

        this.setStatusCheckBoxTitular = (idOperator, status) => {
            let lista = this.state.checkOperadoresTitular.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadoresTitular: lista })
        }

        this.setStatusCheckBoxAllTitular = (status) => {
            let lista = this.state.checkOperadoresTitular.map((operador) => {
                return { id: operador.id, status: status }
            })
            this.setState({ checkOperadoresTitular: lista })
        }

        this.enrocarNomina = () => {
            this.setState({ enroque: true })
        }

        this.cancelarEnroque = () => {
            this.setState({ enroque: false })
            this.setStatusCheckBoxAll(false)
            this.setStatusCheckBoxAllTitular(false)
        }

        this.setStatusCheckBoxEnroqueTitular = (idOperator, status, nombreCorto, unidadesContadas) => {
            let lista = this.state.checkOperadoresTitular.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadoresTitular: lista })
        }

        this.setStatusCheckBoxEnroqueReemplazo = (idOperator, status, nombreCorto, unidadesContadas) => {
            let lista = this.state.checkOperadores.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadores: lista })
        }

        this.showPendientesRegion = () => {
            this.setState({ showPendientesRegion: true })
        };

        this.hidePendientesRegion = () => {
            this.setState({ showPendientesRegion: false })
        };

        this.onChangeSelectedPemiso = (e) => {
            this.setState({ selectedPermisoId: e.target.value })
        }

        this.onChangeActivarPermisoMall = (e) => {
            this.setState({ activarPermisoMall: e.target.checked })
        }

        this.getPermisoSelected = () => {
            const permisoMall = this.props.nomina.permisos_mall.find((permiso) => permiso.id == this.state.selectedPermisoId);
            return permisoMall;
        }

        this.getCantUsuariosPermiso = (selectedPermisoId) => {
            const permisoMall = this.props.nomina.permisos_mall.find((permiso) => permiso.id == selectedPermisoId);
            let count = 0;
            if (this.props.nomina.lider != null) {
                if (this.props.nomina.lider.incluir_permisomall && this.props.nomina.lider.incluir_permisomall == selectedPermisoId) {
                    count++;
                }
            }

            if (this.props.nomina.supervisor != null) {
                if (this.props.nomina.supervisor.incluir_permisomall && this.props.nomina.supervisor.incluir_permisomall == selectedPermisoId) {
                    count++;
                }
            }

            for (const operador of this.props.captadorSEI.dotacionTitular) {
                if (operador.incluir_permisomall && operador.incluir_permisomall == selectedPermisoId) {
                    if (this.props.nomina.lider != null && operador.id == this.props.nomina.lider.id) {
                        continue;
                    }
                    if (this.props.nomina.supervisor != null && operador.id == this.props.nomina.supervisor.id) {
                        continue;
                    }
                    count++;
                }
            }

            for (const operador of this.props.captadorSEI.dotacionReemplazo) {
                if (operador.incluir_permisomall && operador.incluir_permisomall == selectedPermisoId) {
                    if (this.props.nomina.lider != null && operador.id == this.props.nomina.lider.id) {
                        continue;
                    }
                    if (this.props.nomina.supervisor != null && operador.id == this.props.nomina.supervisor.id) {
                        continue;
                    }
                    count++;
                }
            }
            return count;
        }

        this.calcularPermisoCompleto = (selectedPermisoId) => {
            const permisoMall = this.props.nomina.permisos_mall.find((permiso) => permiso.id == selectedPermisoId);
            const max_usuarios = permisoMall ? permisoMall.tipo_permiso.max_usuarios : 0;
            const count = this.getCantUsuariosPermiso(selectedPermisoId);
            return count >= max_usuarios;
        }
        this.abrirAvisoReemplazos = () => {
            this.setState({ avisoReemplazosVisible: true })
        };
        this.cerrarAvisoReemplazos = () => {
            this.setState({ avisoReemplazosVisible: false })
        };
    }


    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            const sortedOperators = nextProps.captadorSEI.dotacionReemplazo.sort((a, b) => {
                if (a.esLider && !b.esLider) return -1;
                if (!a.esLider && b.esLider) return 1;
                return a.nombreCorto.localeCompare(b.nombreCorto);
            });

            this.setState({ substitutesOperatorsRaw: sortedOperators }, () => this.filterOperators());
            this.setState({ titularOperatorsRaw: nextProps.captadorSEI.dotacionTitular });
        }
    }
    render() {
        let totalAgregados = this.props.captadorSEI.dotacionTitular.length
        let rowsTitulares = this.props.maximoOperadores > totalAgregados ? this.props.maximoOperadores : totalAgregados

        let totalReemplazos = this.state.substitutesOperators.length
        let totalAlternativeLeaders = this.props.captadorSEI.alternativeLeaders.length
        var rowsReemplazo = totalReemplazos + 1

        let rowsEscondidos = this.props.captadorSEI.dotacionEscondida.length
        let stock = this.props.nomina.local_stock

        const isPermisoMall = this.props.nomina.local_mall && this.props.nomina.permisos_mall.length > 0;
        const usersConPermisosMap = new Map();
        this.props.nomina.permisos_mall.forEach((permiso) => {
            permiso.users_registrados.forEach((userRegistrado) => {
                if (userRegistrado.user_id != null) {
                    usersConPermisosMap.set(userRegistrado.user_id, userRegistrado);
                }

            })
        });

        const ordenUserPermiso = new Map();
        let orden = (totalAgregados + rowsEscondidos) + (this.props.supervisor ? 1 : 0) + 2; //+1 lider
        [...this.props.captadorSEI.dotacionReemplazo].sort((a, b) => a.orden_permisomall - b.orden_permisomall).forEach((operador) => {
            if (operador.orden_permisomall <= 1 || !operador.incluir_permisomall) {
            } else {
                ordenUserPermiso.set(operador.id, orden);
                orden++;
            }
        });

        return (
            <div>
                <div className="row">
                    <div className="col-md-4">
                        <h2>
                            {this.props.captadorSEI.nombre}
                            <small> {totalAgregados} de {this.props.maximoOperadores} operadores agregados </small>
                            {this.props.editarOperadores ?
                                <BotonAgregaOperador
                                    buscarOperadores={this.props.buscarOperadores}
                                />
                                :
                                null
                            }
                        </h2>
                    </div>
                    <div className="col-md-3" style={{ display: 'flex', gap: '2px' }}>
                        {this.props.verNominaAvanzada ? <div style={{ marginTop: "25px" }}><TarifaNomina nomina={this.props.nomina} /></div> : null}
                        {this.props.verPasajesNomina ? <div style={{ marginTop: "25px" }}><Pasaje nomina={this.props.nomina} administraPasajes={this.props.administraPasajes} /></div> : null}
                    </div>
                    {/*this.props.nominaInformada ? <div className="col-md-2">
                        {this.state.enroque ? <BotonEnrocarOperadores
                            titulares={this.state.checkOperadoresTitular}
                            reemplazos={this.state.checkOperadores}
                            enrocarOperadores={this.props.enrocarOperadores}
                            cancelarEnroque={this.cancelarEnroque}
                            mensaje={this.props.message}
                            nivelConteo={this.props.nivelConteo}
                            idNomina={this.props.idNomina}
                            sumaUnidades={this.props.sumaUnidades}
                            stock={stock}>
                        </BotonEnrocarOperadores> : <button style={{marginTop: "25px", marginRight: '5px', visibility: 'hidden'}} className="btn btn-success">Enrocar</button>}
                        {this.state.enroque ? <button style={{marginTop: "25px"}} className="btn btn-danger" onClick={() => this.cancelarEnroque()}>Cancelar</button>: <button style={{marginTop: "25px", alignSelf: 'right'}} className="btn btn-info" onClick={() => this.enrocarNomina()}>Enroque</button>}
                        </div> : <div className="col-md-2"></div>*/}
                    {/* <div className="col-md-2">
                        <SelectAlternateLeader
                            alternateLeaders={this.props.alternateLeaders}
                            addAlternateLeader={this.context.addAlternateLeader}
                        />
                    </div> */}
                    {isPermisoMall
                        ? <div className="col-md-2">
                            <div style={{ display: 'flex', gap: '4px', flexDirection: 'row', alignItems: 'flex-end' }}>
                                <div style={{ fontSize: '18px' }}>{`(${this.props.cantUserPermisoMall}/${this.props.maxUsuariosPermisosMall})`}</div>
                                <BotonSubirPermisos
                                    checked={this.state.activarPermisoMall}
                                    onChangeActivarPermisoMall={this.onChangeActivarPermisoMall}
                                    permisosMall={this.props.nomina.permisos_mall}
                                    idNomina={this.props.idNomina}
                                    notificator={this.props.notificator}
                                />
                            </div>
                        </div> : <div className="col-md-2"></div>}
                    {/* <div className="col-md-1" style={{ display: 'flex', gap: '2px', marginTop: "25px" }}> */}
                    <div className="col-md-2" style={{ display: 'flex', gap: '2px', marginTop: "25px" }}>
                        <button className="btn btn-primary"
                            onClick={this.showPendientesRegion}>Pendientes
                        </button>
                        {this.props.puedeInformarDisponibilidad ?
                            <div style={{ position: 'relative' }}>
                                <button className="btn btn-success"
                                    onClick={this.abrirAvisoReemplazos}
                                    title="Informar la disponibilidad del servicio a los operadores de reemplazo"
                                >Avisar a reemplazos
                                </button>
                                {this.state.avisoReemplazosVisible ?
                                    <MiniAvisoReemplazos
                                        idNomina={this.props.idNomina}
                                        notificator={this.props.notificator}
                                        onCerrar={this.cerrarAvisoReemplazos}
                                    />
                                    : null}
                            </div>
                            : null}
                        <ModalPendientesRegion show={this.state.showPendientesRegion}
                            cambiarDePanel={this.context.cambiarDePanelPendientes}
                            hideModal={this.hidePendientesRegion}
                            idNomina={this.props.idNomina}
                            notificator={this.props.notificator}
                        />
                    </div>

                </div>
                <div className="row">
                    {/* Dotacion titular */}
                    <div className="col-md-7">
                        <PanelUsuarios isPermisoMall={isPermisoMall} titulo={`Dotación Títular, ${this.props.message}`} clase={panelConteo[this.props.nivelConteo]}>
                            {/* Lider */}
                            <RowOperadorSEI
                                editable={this.props.editarLiderSupervisor}
                                correlativo={"L"}
                                personal={this.props.lider}
                                cargo="Lider"
                                agregarUsuario={this.context.agregarLider}
                                quitarUsuario={this.context.quitarLider}
                                isPermisoMall={isPermisoMall}
                                tienePermisoMall={this.props.lider != null ? usersConPermisosMap.has(this.props.lider.id) : false}
                                idNomina={this.props.nomina.idNomina}
                                activarPermisoMall={this.state.activarPermisoMall}
                                //selectedPermisoId={this.state.selectedPermisoId}
                                permisoCompleto={this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall}
                                notificator={this.props.notificator}
                            />
                            {/* Supervisor */}
                            <RowOperadorSEI
                                editable={this.props.editarLiderSupervisor}
                                correlativo={"S"}
                                personal={this.props.supervisor}
                                cargo="Supervisor"
                                agregarUsuario={this.context.agregarSupervisor}
                                quitarUsuario={this.context.quitarSupervisor}
                                isPermisoMall={isPermisoMall}
                                tienePermisoMall={this.props.supervisor != null ? usersConPermisosMap.has(this.props.supervisor.id) : false}
                                idNomina={this.props.nomina.idNomina}
                                activarPermisoMall={this.state.activarPermisoMall}
                                //selectedPermisoId={this.state.selectedPermisoId}
                                permisoCompleto={this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall}
                                notificator={this.props.notificator}
                            />
                            {_.range(0, rowsTitulares).map(index => {
                                let operador = this.props.captadorSEI.dotacionTitular[index]
                                let checkbox = this.state.checkOperadoresTitular[index];
                                return <RowOperadorSEI
                                    //editarTodasNominas = {this.props.editarTodasNominas}
                                    editable={this.props.editarOperadores}
                                    key={operador ? operador.id : 't' + index}
                                    correlativo={'' + (index + 1)}
                                    personal={operador}
                                    cargo={operador ? operador.role : "Operador"}
                                    checkboxStatus={checkbox ? checkbox.status : false}
                                    setStatusCheckBoxEnroqueTitular={this.setStatusCheckBoxEnroqueTitular.bind(this)}
                                    agregarUsuario={this.context.agregarOperador.bind(this, true, this.props.captadorSEI.idCaptador)}
                                    quitarUsuario={this.context.quitarOperador}
                                    cambiarDePanel={this.context.cambiarDePanel}
                                    idCaptador={this.props.captadorSEI.idCaptador}
                                    rectificada={this.props.rectificada}
                                    operadorTitularId={this.props.operadorTitularId}
                                    difOperadores={this.props.difOperadores}
                                    nuevoOperador={this.props.nuevoOperador}
                                    showSeleccionOperador={this.props.showSeleccionOperador}
                                    buscarOperadores={this.props.buscarOperadores}
                                    blockOperador={this.context.blockOperador}
                                    // idNomina={this.props.idNomina}
                                    enroque={this.state.enroque}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={operador ? usersConPermisosMap.has(operador.id) : false}
                                    comunaInventario={this.props.nomina.local_comuna}
                                    idNomina={this.props.nomina.idNomina}
                                    activarPermisoMall={this.state.activarPermisoMall}
                                    //selectedPermisoId={this.state.selectedPermisoId}
                                    permisoCompleto={this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall}
                                    notificator={this.props.notificator}
                                />
                            })}
                            {this.props.nuevoOperador ?
                                <RowOperadorSEI
                                    editable={true}
                                    nuevoOperador={true}
                                    correlativo={<span className="glyphicon glyphicon-random" aria-hidden="true"></span>}
                                    rectificada={this.props.rectificada}
                                    agregarUsuario={this.context.agregarOperador.bind(this, true, this.props.captadorSEI.idCaptador)}
                                    onCancelarAgregarOperador={this.props.onCancelarAgregarOperador}
                                    operadorTitularId={this.props.operadorTitularId}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={usersConPermisosMap.has(operador.id)}
                                />
                                :
                                null
                            }
                            <RowOperadorSEI
                                editable={false}
                                correlativo={"U"}
                                sumaUnidades={this.props.sumaUnidades}
                                sumaConteo={this.props.sumaConteo}
                                isPermisoMall={isPermisoMall}
                            />
                            <RowOperadorSEI
                                editable={false}
                                correlativo={"D"}
                                diferenciaUnidades={this.props.diferenciaUnidades}
                                diferenciaConteo={this.props.diferenciaConteo}
                                isPermisoMall={isPermisoMall}
                            />
                            {rowsEscondidos > 0 ?
                                <tr>
                                    <td>-</td>
                                    <td>Escondidos</td>
                                </tr> : null}
                            {_.range(0, rowsEscondidos).map(index => {
                                let operador = this.props.captadorSEI.dotacionEscondida[index]
                                let checkbox = this.state.checkOperadoresTitular[index];
                                return <RowOperadorSEIEscondido
                                    //editarTodasNominas = {this.props.editarTodasNominas}
                                    editable={this.props.editarOperadores}
                                    key={operador ? operador.id : 't' + index}
                                    correlativo={'' + (index + 1)}
                                    personal={operador}
                                    cargo={operador ? operador.role : "Operador"}
                                    checkboxStatus={checkbox ? checkbox.status : false}
                                    setStatusCheckBoxEnroqueTitular={this.setStatusCheckBoxEnroqueTitular.bind(this)}
                                    quitarEscondido={this.context.quitarEscondido}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={operador ? usersConPermisosMap.has(operador.id) : false}
                                    idNomina={this.props.nomina.idNomina}
                                    activarPermisoMall={this.state.activarPermisoMall}
                                    //selectedPermisoId={this.state.selectedPermisoId}
                                    permisoCompleto={this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall}
                                    notificator={this.props.notificator}
                                />
                            })}
                        </PanelUsuarios>
                    </div>

                    {/* Dotacion Reemplazo */}
                    <div className="col-md-5">
                        {/* Dotacion reemplazo */}
                        <PanelUsuariosReemplazoSEI
                            isPermisoMall={isPermisoMall}
                            titulo="Dotación Reemplazo"
                            clase={panelConteo[0]}
                            searchingRUN={this.searchingText.bind(this, 'valueSearchRUN')}
                            searchingName={this.searchingText.bind(this, 'valueSearchName')}
                            searchingComuna={this.searchingText.bind(this, 'valueSearchComuna')}
                            valueSearchRUN={this.state.valueSearchRUN}
                            valueSearchName={this.state.valueSearchName}
                            valueSearchComuna={this.state.valueSearchComuna}
                            setStatusCheckBoxAll={this.setStatusCheckBoxAll.bind(this)}
                            quitarOperadoresMasivo={this.props.quitarOperadoresMasivo.bind(this, this.state.checkOperadores)}
                            operadorTitularMasivo={this.props.operadorTitularMasivo.bind(this, this.state.checkOperadores)}
                            editable={this.props.editarOperadores}
                        >
                            {_.range(0, totalAlternativeLeaders).map(index => {
                                let operador = this.props.captadorSEI.alternativeLeaders[index]
                                const numOrden = ordenUserPermiso.has(operador.id) ? ordenUserPermiso.get(operador.id) : '';
                                return <RowOperadorReemplazo
                                    editable={this.props.editarOperadores}
                                    key={operador ? operador.id : 'r' + index}
                                    correlativo={'LS'}
                                    personal={operador}
                                    cargo="Lider Suplente"
                                    agregarUsuario={this.context.agregarOperador.bind(this, false, this.props.captadorSEI.idCaptador)}
                                    quitarUsuario={this.context.quitarOperador}
                                    suspendOperator={this.context.supendOperator}
                                    cambiarDePanel={this.context.cambiarDePanel}
                                    idCaptador={this.props.captadorSEI.idCaptador}
                                    rectificada={this.props.rectificada}
                                    buscarOperadores={this.props.buscarOperadores}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={operador ? usersConPermisosMap.has(operador.id) : false}
                                />
                            })}
                            {_.range(0, rowsReemplazo).map(index => {
                                let operador = this.state.substitutesOperators[index]
                                let checkbox = this.state.checkOperadores[index];
                                if (operador) {
                                    operador = {
                                        ...this.state.substitutesOperators[index],
                                        orden_permisomall: ordenUserPermiso.has(operador.id) ? ordenUserPermiso.get(operador.id) : ''
                                    };
                                }
                                return <RowOperadorReemplazoSEI
                                    //editarTodasNominas = {this.props.editarTodasNominas}
                                    editable={this.props.editarOperadores}
                                    key={operador ? operador.id : 'r' + index}
                                    correlativo={'' + (index + 1)}
                                    personal={operador}
                                    checkboxStatus={checkbox ? checkbox.status : false}
                                    cargo="Operador"
                                    setStatusCheckBox={this.setStatusCheckBox.bind(this)}
                                    setStatusCheckBoxEnroqueReemplazo={this.setStatusCheckBoxEnroqueReemplazo.bind(this)}
                                    agregarUsuario={this.context.agregarOperador.bind(this, false, this.props.captadorSEI.idCaptador)}
                                    quitarUsuario={this.context.quitarOperador}
                                    suspendOperator={this.context.suspendOperator}
                                    cambiarDePanel={this.context.cambiarDePanel}
                                    idCaptador={this.props.captadorSEI.idCaptador}
                                    rectificada={this.props.rectificada}
                                    buscarOperadores={this.props.buscarOperadores}
                                    enroque={this.state.enroque}
                                    cliente={this.props.cliente}
                                    puedeAsignar={this.props.puedeAsignar}
                                    operadorEscondido={this.props.operadorEscondido.bind(this)}
                                    fechaInventario={this.props.nomina.inv_fechaProgramada}
                                    cambiarCaptador={this.context.cambiarCaptador}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={operador ? usersConPermisosMap.has(operador.id) : false}
                                    idNomina={this.props.nomina.idNomina}
                                    activarPermisoMall={this.state.activarPermisoMall}
                                    //selectedPermisoId={this.state.selectedPermisoId}
                                    permisoCompleto={this.props.cantUserPermisoMall >= this.props.maxUsuariosPermisosMall}
                                    notificator={this.props.notificator}
                                />
                            })}
                        </PanelUsuariosReemplazoSEI>
                    </div>
                </div>
            </div>
        )
    }
}
PanelCaptadorSEI.contextTypes = {
    agregarLider: PropTypes.func,
    quitarLider: PropTypes.func,
    agregarSupervisor: PropTypes.func,
    quitarSupervisor: PropTypes.func,
    agregarOperador: PropTypes.func,
    quitarOperador: PropTypes.func,
    cambiarDePanel: PropTypes.func,
    cambiarDePanelPendientes: PropTypes.func,
    getOperadoresDisponibles: PropTypes.func,
    addAlternateLeader: PropTypes.func,
    suspendOperator: PropTypes.func,
    blockOperador: PropTypes.func,
    enrocarNomina: PropTypes.func,
    changeTurnoAvanzada: PropTypes.func,
    quitarEscondido: PropTypes.func,
    cambiarCaptador: PropTypes.func
}

export class PanelDetainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            substitutesOperatorsRaw: this.props.captador.dotacionReemplazo,
            substitutesOperators: [],
            titularOperatorsRaw: this.props.captador.dotacionTitular,
            titularOperators: [],
            valueSearchRUN: '',
            valueSearchName: '',
            valueSearchComuna: '',
            checkOperadores: [],
            checkOperadoresTitular: [],
            enroque: false
        }
        this.searchingText = (camp, originalSearch) => {
            let newState = {}
            newState[camp] = originalSearch.trim().toLowerCase()
            this.setState(newState, this.filterOperators)
        }
        /*this.filterOperators = () => {
            this.setState({
                substitutesOperators: this.state.substitutesOperatorsRaw
                    .filter(us => us.usuarioRUN.indexOf(this.state.valueSearchRUN) >= 0)
                    .filter(us => us.nombreCorto.toLowerCase().indexOf(this.state.valueSearchName) >= 0)
                    .filter(us => us.comuna.toLowerCase().indexOf(this.state.valueSearchComuna) >= 0)
            })
        }*/
        this.filterOperators = () => {
            let titulares = this.state.titularOperatorsRaw
            let substitutes = this.state.substitutesOperatorsRaw
                .filter(us => us.usuarioRUN.indexOf(this.state.valueSearchRUN) >= 0)
                .filter(us => us.nombreCorto.toLowerCase().indexOf(this.state.valueSearchName) >= 0)
                .filter(us => us.comuna.toLowerCase().indexOf(this.state.valueSearchComuna) >= 0);
            let listCheck = substitutes.map((operador) => {
                return { id: operador.id, status: false }
            });
            let listCheckTitular = titulares.map((operador) => {
                return { id: operador.id, status: false }
            })
            this.setState({
                substitutesOperators: substitutes,
                checkOperadores: listCheck,
                titularOperators: titulares,
                checkOperadoresTitular: listCheckTitular
            })
        }

        this.setStatusCheckBox = (idOperator, status) => {
            let lista = this.state.checkOperadores.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadores: lista })
        }

        this.setStatusCheckBoxAll = (status) => {
            let lista = this.state.checkOperadores.map((operador) => {
                return { id: operador.id, status: status }
            })
            this.setState({ checkOperadores: lista })
        }

        this.setStatusCheckBoxTitular = (idOperator, status) => {
            let lista = this.state.checkOperadoresTitular.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadoresTitular: lista })
        }

        this.setStatusCheckBoxAllTitular = (status) => {
            let lista = this.state.checkOperadoresTitular.map((operador) => {
                return { id: operador.id, status: status }
            })
            this.setState({ checkOperadoresTitular: lista })
        }

        this.enrocarNomina = () => {
            this.setState({ enroque: true })
        }

        this.cancelarEnroque = () => {
            this.setState({ enroque: false })
            this.setStatusCheckBoxAll(false)
            this.setStatusCheckBoxAllTitular(false)
        }

        this.setStatusCheckBoxEnroqueTitular = (idOperator, status, nombreCorto, unidadesContadas) => {
            let lista = this.state.checkOperadoresTitular.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadoresTitular: lista })
        }

        this.setStatusCheckBoxEnroqueReemplazo = (idOperator, status, nombreCorto, unidadesContadas) => {
            let lista = this.state.checkOperadores.map((operador) => {
                if (operador.id == idOperator) {
                    return { id: idOperator, status: status, nombre: nombreCorto, conteo: unidadesContadas }
                } else {
                    return operador;
                }
            })
            this.setState({ checkOperadores: lista })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ substitutesOperatorsRaw: nextProps.captador.dotacionReemplazo.sort((a, b) => a.nombreCorto.localeCompare(b.nombreCorto)) }, () => this.filterOperators());
        }
    }
    render() {
        let operadoresAsignados = this.props.captador.operadoresAsignados
        let totalAgregados = this.props.captador.dotacionTitular.length
        let rowsTitulares = operadoresAsignados > totalAgregados ? operadoresAsignados : totalAgregados

        let totalReemplazos = this.state.substitutesOperators.length
        let rowsReemplazo = totalReemplazos + 1

        let stock = this.props.nomina.local_stock

        const isPermisoMall = this.props.nomina.local_mall && this.props.nomina.permisos_mall.length > 0;
        const usersConPermisosMap = new Map();
        this.props.nomina.permisos_mall.forEach((permiso) => {
            permiso.users_registrados.forEach((userRegistrado) => {
                if (userRegistrado.user_id != null) {
                    usersConPermisosMap.set(userRegistrado.user_id, userRegistrado);
                }

            })
        });
        return (
            <div>
                <div className='row'>
                    <div className="col-md-5">
                        <h2>
                            {this.props.captador.nombre}
                            <small> {totalAgregados} de {operadoresAsignados} operadores agregados  </small>
                        </h2>
                    </div>
                    {/*this.props.nominaInformada ? <div className="col-md-2">
                            {this.state.enroque ? <BotonEnrocarOperadores
                                titulares={this.state.checkOperadoresTitular}
                                reemplazos={this.state.checkOperadores}
                                enrocarOperadores={this.props.enrocarOperadores}
                                cancelarEnroque={this.cancelarEnroque}
                                mensaje={this.props.message}
                                nivelConteo={this.props.nivelConteo}
                                idNomina={this.props.idNomina}
                                sumaUnidades={this.props.sumaUnidades}
                                stock={stock}>
                            </BotonEnrocarOperadores> : <button style={{marginTop: "25px", marginRight: '5px', visibility: 'hidden'}} className="btn btn-success">Enrocar</button>}
                            {this.state.enroque ? <button style={{marginTop: "25px"}} className="btn btn-danger" onClick={() => this.cancelarEnroque()}>Cancelar</button>: <button style={{marginTop: "25px", alignSelf: 'right'}} className="btn btn-info" onClick={() => this.enrocarNomina()}>Enroque</button>}
                        </div> : <div className="col-md-2"></div>*/}
                </div>
                <div className="row">
                    {/* Dotacion titular */}
                    <div className="col-md-7">
                        <PanelUsuarios isPermisoMall={isPermisoMall} titulo={`Dotación Títular, ${this.props.message}`} clase={panelConteo[this.props.nivelConteo]}>
                            {_.range(0, rowsTitulares).map(index => {
                                let operador = this.props.captador.dotacionTitular[index]
                                let checkbox = this.state.checkOperadoresTitular[index];
                                return <RowOperador
                                    //editarTodasNominas = {this.props.editarTodasNominas}
                                    editable={this.props.editarOperadores}
                                    key={operador ? operador.id : 't' + index}
                                    correlativo={'' + (index + 1)}
                                    personal={operador}
                                    cargo="Operador"
                                    agregarUsuario={this.context.agregarOperador.bind(this, true, this.props.captador.idCaptador)}
                                    quitarUsuario={this.context.quitarOperador}
                                    cambiarDePanel={this.context.cambiarDePanel}
                                    idCaptador={this.props.captador.idCaptador}
                                    rectificada={this.props.rectificada}
                                    difOperadores={this.props.difOperadores}
                                    buscarOperadores={this.props.buscarOperadores}
                                    enroque={this.state.enroque}
                                    checkboxStatus={checkbox ? checkbox.status : false}
                                    setStatusCheckBoxEnroqueTitular={this.setStatusCheckBoxEnroqueTitular.bind(this)}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={operador ? usersConPermisosMap.has(operador.id) : false}
                                />
                            })}
                            <RowOperador
                                editable={false}
                                correlativo={"U"}
                                estado={this.props.captador.estado}
                                sumaUnidades={this.props.sumaUnidades}
                                isPermisoMall={isPermisoMall}
                            />
                            <RowOperador
                                editable={false}
                                correlativo={"D"}
                                diferenciaUnidades={this.props.diferenciaUnidades}
                                isPermisoMall={isPermisoMall}
                            />
                        </PanelUsuarios>
                    </div>
                    {/* Dotacion reemplazo */}
                    <div className="col-md-5">
                        <PanelUsuariosReemplazo
                            isPermisoMall={isPermisoMall}
                            titulo="Dotación Reemplazo"
                            clase={panelConteo[0]}
                            searchingRUN={this.searchingText.bind(this, 'valueSearchRUN')}
                            searchingName={this.searchingText.bind(this, 'valueSearchName')}
                            searchingComuna={this.searchingText.bind(this, 'valueSearchComuna')}
                            valueSearchRUN={this.state.valueSearchRUN}
                            valueSearchName={this.state.valueSearchName}
                            valueSearchComuna={this.state.valueSearchComuna}
                        >
                            {_.range(0, rowsReemplazo).map(index => {
                                let operador = this.state.substitutesOperators[index]
                                let checkbox = this.state.checkOperadores[index];
                                return <RowOperadorReemplazo
                                    //editarTodasNominas = {this.props.editarTodasNominas}
                                    editable={this.props.editarOperadores}
                                    key={operador ? operador.id : 'r' + index}
                                    correlativo={'R'}
                                    personal={operador}
                                    cargo="Operador"
                                    agregarUsuario={this.context.agregarOperador.bind(this, false, this.props.captador.idCaptador)}
                                    quitarUsuario={this.context.quitarOperador}
                                    suspendOperator={this.context.suspendOperator}
                                    cambiarDePanel={this.context.cambiarDePanel}
                                    idCaptador={this.props.captador.idCaptador}
                                    rectificada={this.props.rectificada}
                                    buscarOperadores={this.props.buscarOperadores}
                                    enroque={this.state.enroque}
                                    setStatusCheckBox={this.setStatusCheckBox.bind(this)}
                                    setStatusCheckBoxEnroqueReemplazo={this.setStatusCheckBoxEnroqueReemplazo.bind(this)}
                                    checkboxStatus={checkbox ? checkbox.status : false}
                                    fechaInventario={this.props.nomina.inv_fechaProgramada}
                                    isPermisoMall={isPermisoMall}
                                    tienePermisoMall={operador ? usersConPermisosMap.has(operador.id) : false}
                                />
                            })}
                        </PanelUsuariosReemplazo>
                    </div>
                </div>
            </div>
        )
    }
}
PanelDetainer.contextTypes = {
    agregarOperador: PropTypes.func,
    quitarOperador: PropTypes.func,
    cambiarDePanel: PropTypes.func,
    getOperadoresDisponibles: PropTypes.func,
    suspendOperator: PropTypes.func
}

const PanelUsuarios = ({ isPermisoMall = false, titulo, children, clase }) =>
    <div className={'panel ' + clase}>
        <div className={'panel-heading ' + css.panelHeading_compacto}>{titulo}</div>
        <table className={'table table-striped table-bordered table-hover table-condensed ' + css.tablaDotacion}>
            <colgroup>
                <col className={css.colCorrelativo} />
                <col className={css.colUsuarioRUN} />
                <col className={css.colUsuarioDV} />
                <col className={css.colNombre} />
                <col className={css.colCargo} />
                <col className={css.colComuna} />
                <col className={css.colCaptador} />
                <col className={css.colExp} />
                <col className={css.colError} />
                <col className={css.colConteo} />
                <col className={css.colConteoReal} />
                <col className={css.colEstado} />
                <col className={css.colEstadoCI} />
                {isPermisoMall ? <col className={css.colPermisoMall} /> : null}
                <col className={css.colOpciones} />
                <col className={css.colOpciones} />
                <col className={css.colIntercambio} />
            </colgroup>
            <thead>
                <tr>
                    <th>N°</th>
                    <th>RUN</th>
                    <th className={css.thUsuarioDV}>DV</th>
                    <th>Nombre</th>
                    <th>Cargo</th>
                    <th>Comuna</th>
                    <th>Captador</th>
                    <th>Exp</th>
                    <th>Error</th>
                    <th>Sug.</th>
                    <th>Real</th>
                    <th>Contrato</th>
                    <th>CI</th>
                    {isPermisoMall ? <th>Mall</th> : null}
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    </div>
const PanelUsuariosReemplazo = ({ isPermisoMall = false, titulo, children, clase, searchingRUN, searchingName, searchingComuna, valueSearchRUN, valueSearchName, valueSearchComuna }) =>
    <div className={'panel ' + clase}>
        <div className={'panel-heading ' + css.panelHeading_compacto}>{titulo}</div>
        <table className={'table table-striped table-bordered table-hover table-condensed ' + css.tablaDotacion}>
            <colgroup>
                <col className={css.colOpciones} />
                <col className={css.colIntercambio} />
                <col className={css.colIntercambio} />
                <col className={css.colUsuarioRUN} />
                <col className={css.colUsuarioDV} />
                <col className={css.colNombreCorto} />
                <col className={css.colComuna} />
                <col className={css.colCaptador} />
                <col className={css.colExp} />
                <col className={css.colError} />
                <col className={css.colConteo} />
                <col className={css.colConteoReal} />
                <col className={css.colEstado} />
                <col className={css.colEstadoCI} />
                {isPermisoMall ? <col className={css.colPermisoMall} /> : null}
            </colgroup>
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                        <HeaderConBusqueda
                            nombre="RUN"
                            busqueda={valueSearchRUN}
                            realizarBusqueda={searchingRUN}
                        />
                    </th>
                    <th className={css.thUsuarioDV}>DV</th>
                    <th>
                        <HeaderConBusqueda
                            nombre="Nombre"
                            busqueda={valueSearchName}
                            realizarBusqueda={searchingName}
                        />
                    </th>
                    <th>
                        <HeaderConBusqueda
                            nombre="Comuna"
                            busqueda={valueSearchComuna}
                            realizarBusqueda={searchingComuna}
                        />
                    </th>
                    <th>Captador</th>
                    <th>Exp</th>
                    <th>Error</th>
                    <th>Sug.</th>
                    <th>Real</th>
                    <th>Contrato</th>
                    <th>CI</th>
                    {isPermisoMall ? <th>Mall</th> : null}
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    </div>

const PanelUsuariosReemplazoSEI = ({ isPermisoMall = false, operadorTitularMasivo, quitarOperadoresMasivo, setStatusCheckBoxAll, titulo, children, clase, searchingRUN, searchingName, searchingComuna, valueSearchRUN, valueSearchName, valueSearchComuna, editable, puedeAsignar }) => {

    const handleChange = (event) => {
        setStatusCheckBoxAll(event.target.checked);
    }

    const handleClick = () => {
        quitarOperadoresMasivo();
    }

    const handleClickTitular = () => {
        operadorTitularMasivo();
    }

    return (<div className={'panel ' + clase}>
        <div className={'panel-heading ' + css.panelHeading_compacto}>{titulo}</div>
        <table className={'table table-striped table-bordered table-hover table-condensed ' + css.tablaDotacion}>
            <colgroup>
                <col className={css.colCorrelativoSEI} />
                <col className={css.colOpciones} />
                <col className={css.colCheckbox} />
                <col className={css.colIntercambio} />
                <col className={css.colUsuarioRUN} />
                <col className={css.colUsuarioDV} />
                <col className={css.colNombreCorto} />
                <col className={css.colComuna} />
                <col className={css.colCaptador} />
                <col className={css.colExp} />
                <col className={css.colError} />
                <col className={css.colConteo} />
                <col className={css.colConteoReal} />
                <col className={css.colEstado} />
                <col className={css.colEstadoCI} />
                {isPermisoMall ? <col className={css.colPermisoMall} /> : null}
            </colgroup>
            <thead>
                <tr>
                    <th>#</th>
                    <th>
                        {editable ? <button className="btn btn-xs btn-info glyphicon glyphicon-triangle-left"
                            onClick={handleClickTitular}
                            title="Cambiar a nómina titular"
                        ></button> : null}
                    </th>
                    <th>{editable ? <input type="checkbox" onChange={handleChange} /> : null}</th>
                    <th>
                        {editable ? <button className="btn btn-xs btn-danger glyphicon glyphicon-remove"
                            onClick={handleClick}
                            title="Quitar Operador nómina reemplazo"
                        ></button> : null}
                    </th>
                    <th>
                        <HeaderConBusqueda
                            nombre="RUN"
                            busqueda={valueSearchRUN}
                            realizarBusqueda={searchingRUN}
                        />
                    </th>
                    <th className={css.thUsuarioDV}>DV</th>
                    <th>
                        <HeaderConBusqueda
                            nombre="Nombre"
                            busqueda={valueSearchName}
                            realizarBusqueda={searchingName}
                        />
                    </th>
                    <th>
                        <HeaderConBusqueda
                            nombre="Comuna"
                            busqueda={valueSearchComuna}
                            realizarBusqueda={searchingComuna}
                        />
                    </th>
                    <th>Captador</th>
                    <th>Exp</th>
                    <th>Error</th>
                    <th>Sug.</th>
                    <th>Real</th>
                    <th>Contrato</th>
                    <th>CI</th>
                    {isPermisoMall ? <th>Mall</th> : null}
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    </div>);
}
const BotonAgregaOperador = ({ buscarOperadores }) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal) =>
            <button className="btn btn-xs btn-success" disabled={buscarOperadores} onClick={showModal}>
                <span className={'glyphicon glyphicon-search'}></span> Buscar Operador
                {isVisible && <ModalAgregaOperador
                    hideModal={hideModal}
                />}
            </button>
        }
    </ModalTrigger>

const BotonEnrocarOperadores = ({ titulares, reemplazos, enrocarOperadores, cancelarEnroque, mensaje, nivelConteo, idNomina, sumaUnidades, stock }) => {
    let arraytitular = []
    titulares.map(op => {
        if (op.status == true) {
            return arraytitular.push({ id: op.id, nombre: op.nombre, conteo: op.conteo })
        }
    })
    let arrayreemplazo = []
    reemplazos.map(op => {
        if (op.status == true) {
            return arrayreemplazo.push({ id: op.id, nombre: op.nombre, conteo: op.conteo })
        }
    })
    return <ModalTrigger>
        {(isVisible, showModal, hideModal) =>
            <button style={{ marginTop: "25px", marginRight: '5px' }} className="btn btn-success"
                onClick={showModal}>Enrocar
                {isVisible && <ModalEnrocarOperadores
                    hideModal={hideModal}
                    titulares={arraytitular}
                    reemplazos={arrayreemplazo}
                    enrocarOperadores={enrocarOperadores}
                    cancelarEnroque={cancelarEnroque}
                    mensaje={mensaje}
                    nivelConteo={nivelConteo}
                    idNomina={idNomina}
                    sumaUnidades={sumaUnidades}
                    stock={stock}
                />}
            </button>

        }
    </ModalTrigger>
}

export class BotonSubirPermisos extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null
        }
    }

    subirPermisos = () => {
        fetch(`/api/nomina/subir-permisomall`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idNomina: this.props.idNomina
            })
        }).then(response => {
            return response.json().then(json => {
                if (!response.ok) {
                    throw json;
                }
                return json;
            })
        }).then(data => {
            this.context.setPermisosMallNomina(data)
            this.actualizarIntervaloPermisosMall();
        }).catch(error => {
            const message = error.message || 'Error al subir permisos';
            this.props.notificator.error('Error al subir permisos', message, 4000);
            this.setState({ error: 'Error al subir permisos' });
        });
    }

    onClick = () => {
        const confirmed = window.confirm('¿Estás seguro de subir los permisos?')

        if (!confirmed) {
            return
        }

        this.subirPermisos()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.permisosMall !== this.props.permisosMall) {
            this.actualizarIntervaloPermisosMall();
        }
    }

    componentDidMount() {
        this.actualizarIntervaloPermisosMall();
    }

    actualizarIntervaloPermisosMall = () => {
        const subiendo = this.props.permisosMall.filter(permiso => permiso.subiendo_permiso).length;
        const completados = this.props.permisosMall.filter(permiso => permiso.completado).length;

        if (subiendo === 0 || completados === this.props.permisosMall.length) {
            console.log('[Permisos Mall] Deteniendo consulta periódica: no hay permisos subiendo');
            clearInterval(this.permisosMallInterval);
            this.permisosMallInterval = null;
            return;
        }

        if (this.permisosMallInterval) {
            return;
        }

        console.log('[Permisos Mall] Iniciando consulta periódica', { subiendo });
        this.permisosMallInterval = setInterval(() => {
            console.log('[Permisos Mall] Consultando estado');
            fetch(`/api/nomina/status-permisosmall?idNomina=${this.props.idNomina}`, {
                method: 'GET',
            }).then(response => {
                return response.json().then(json => {
                    if (!response.ok) {
                        throw json;
                    }
                    return json;
                })
            }).then(data => {
                console.log('[Permisos Mall] Estado recibido', data);
                this.context.setPermisosMallNomina(data)

                if (data.filter(permiso => permiso.completado).length == this.props.permisosMall.length) {
                    this.props.notificator.success('Permisos subidos correctamente', 'Éxito', 4000);
                }

            }).catch(error => {
                console.error('Error al consultar el estado de los permisos mall', error);
            });
        }, 10000);
    }

    componentWillUnmount() {
        console.log('[Permisos Mall] Deteniendo consulta periódica: componente desmontado');
        clearInterval(this.permisosMallInterval);
    }

    render() {
        if (this.state.error) {
            return (
                <button className="btn btn-danger" disabled={true}>
                    {this.state.error}
                </button>
            )
        }

        const subiendo = this.props.permisosMall.filter(permiso => permiso.subiendo_permiso).length;
        const completados = this.props.permisosMall.filter(permiso => permiso.completado).length;

        const isSubiendoPermisos = subiendo > 0;
        const isCompletados = completados == this.props.permisosMall.length;
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label className="control-label">
                    <input type="checkbox" checked={this.props.checked} onChange={this.props.onChangeActivarPermisoMall} />
                    <span style={{ marginLeft: '4px' }}>Nomina Permiso Mall</span>
                </label>
                {isCompletados
                    ? <button className="btn btn-success" disabled={true}>
                        Permiso cargado
                        <span className="glyphicon glyphicon-ok" style={{ marginLeft: '5px' }}></span>
                    </button>
                    : <button className="btn btn-primary" disabled={isSubiendoPermisos} onClick={this.onClick}>
                        {isSubiendoPermisos ? `Subiendo... (${subiendo}/${this.props.permisosMall.length})` : 'Subir Permisos'}
                    </button>
                }
            </div>
        )
    }
}

BotonSubirPermisos.contextTypes = {
    setPermisosMallNomina: PropTypes.func,
}

// Mini panel para informar la disponibilidad del servicio a los reemplazos.
// Consulta en vivo cuántos reemplazos hay disponibles para notificar (lista completa)
// y permite indicar cuántos cupos (vacantes) del servicio se informarán. Los cupos son
// independientes de la cantidad de usuarios notificados.
class MiniAvisoReemplazos extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            error: null,
            data: null,
            cupos: 0,
            enviando: false
        }
        this.consultar = () => {
            // El modal abre con cupos en 0: no se pre-carga el total de usuarios
            // a notificar. El valor se setea solo cuando el usuario interactúa con
            // el input. Al re-consultar se resetea para no arrastrar el valor anterior.
            this.setState({ loading: true, error: null, cupos: 0 })
            api.nomina(this.props.idNomina).disponibilidadReemplazos()
                .then(data => {
                    this.setState({ loading: false, data })
                })
                .catch(() => {
                    this.setState({ loading: false, error: 'No se pudo consultar la cantidad de reemplazos disponibles' })
                })
        }
        this.onCupos = (e) => {
            let val = parseInt(e.target.value, 10)
            if (isNaN(val) || val < 0) val = 0
            this.setState({ cupos: val })
        }
        this.enviar = () => {
            const { data, cupos, enviando } = this.state
            if (!data || cupos <= 0 || enviando) return
            this.setState({ enviando: true, error: null })
            api.nomina(this.props.idNomina).informarDisponibilidadReemplazos(cupos)
                .then(data => {
                    const informados = data.informados ? data.informados.length : 0
                    if (this.props.notificator) {
                        this.props.notificator.success("Disponibilidad del servicio", data.mensaje || `Se informó la disponibilidad del servicio a ${informados} reemplazo(s)`, 5 * 1000)
                    }
                    this.props.onCerrar()
                })
                .catch(() => {
                    this.setState({ enviando: false, error: 'Error al informar la disponibilidad del servicio' })
                })
        }
    }
    componentDidMount() {
        this.consultar()
    }
    render() {
        const { loading, error, data, cupos, enviando } = this.state
        const disponibles = data && data.disponibles ? data.disponibles.length : 0
        const excluidos = data && data.excluidos ? data.excluidos.length : 0
        return (
            <div style={{ position: 'absolute', top: '100%', right: 0, zIndex: 1050, width: 340, marginTop: 6, background: '#fff', border: '1px solid #ccc', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 8 }}>Informar disponibilidad del servicio</div>
                {loading ?
                    <div style={{ color: '#777' }}>Consultando reemplazos disponibles...</div>
                    : null}
                {error ?
                    <div style={{ color: '#a94442' }}>{error}</div>
                    : null}
                {data && !loading ?
                    <div>
                        <div><strong>{disponibles}</strong> reemplazo(s) para notificar (lista completa)</div>
                        {excluidos > 0 ?
                            <div style={{ color: '#8a6d3b', fontSize: 12 }}>Se omiten {excluidos} por estar como titular en otro servicio</div>
                            : null}
                        <div style={{ marginTop: 8 }}>
                            <label style={{ fontWeight: 'normal' }}>Cantidad de cupos (vacantes) a informar:</label>
                            <input type="number" value={cupos} onChange={this.onCupos} style={{ width: 70, marginLeft: 6 }} />
                        </div>
                        <div style={{ marginTop: 10, display: 'flex', justifyContent: 'flex-end' }}>
                            <button className="btn btn-default btn-sm" onClick={this.props.onCerrar} disabled={enviando} style={{ marginRight: 6 }}>Cancelar</button>
                            <button className="btn btn-success btn-sm" onClick={this.enviar} disabled={enviando || cupos <= 0}>
                                {enviando ? 'Enviando...' : 'Enviar'}
                            </button>
                        </div>
                    </div>
                    : null}
            </div>
        )
    }
}
MiniAvisoReemplazos.propTypes = {
    idNomina: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    notificator: PropTypes.object,
    onCerrar: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/PanelCaptador.jsx